exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Copyright (c) 2018 Scaper */\n.scpr-RequirePhoneVerifiedOrPrompt-button {\n  background-color: #66d092; }\n", "", {"version":3,"sources":["/Users/promon/Documents/Scaper/workspace/scaper/src/app/auth/src/app/auth/requirePhoneVerifiedOrPrompt.scss"],"names":[],"mappings":"AAAA,+BAA+B;AAE/B;EACI,0BAAyB,EAC5B","file":"requirePhoneVerifiedOrPrompt.scss","sourcesContent":["/* Copyright (c) 2018 Scaper */\n\n.scpr-RequirePhoneVerifiedOrPrompt-button {\n    background-color: #66d092;\n}\n"],"sourceRoot":""}]);

// exports
